<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        {{this.$route.meta.title}}
        <div class="card-header-actions">
          <button
            class="btn btn-primary mr-1"
            @click="save()"
            v-b-tooltip.hover
            title="Save data agunan"
          >
            <i class="fa fa-floppy-o"></i> {{$t('save')}}
          </button>
          <button class="btn btn-danger mr-1" @click="close()">
            <i class="fa fa-close"></i> {{$t('close')}}
          </button>
        </div>
      </div>
      <div slot="footer">
        <div class="text-center">
          <button
            class="btn btn-primary mr-1"
            @click="save()"
            v-b-tooltip.hover
            title="Save data agunan"
          >
            <i class="fa fa-floppy-o"></i> {{$t('save')}}
          </button>
          <button class="btn btn-danger mr-1" @click="close()">
            <i class="fa fa-close"></i> {{$t('close')}}
          </button>
        </div>
      </div>

      <!-- <b-input-group>
        <b-input-group-prepend>
          <label class="lbl-left pt-0">Nama Debitur</label>
        </b-input-group-prepend>
        <b-form-input
          class="form-control-static bg-white"
          readonly
          v-model="model.CustName"
        ></b-form-input>
      </b-input-group>
      <b-input-group>
        <b-input-group-prepend>
          <label class="lbl-left pt-0">Nomor Perjanjian Kredit</label>
        </b-input-group-prepend>
        <b-form-input
          class="form-control-static bg-white"
          readonly
          v-model="model.no_agreement"
        ></b-form-input>
      </b-input-group>
      <b-input-group>
        <b-input-group-prepend>
          <label class="lbl-left pt-0">Nomor Pinjaman</label>
        </b-input-group-prepend>
        <b-form-input
          class="form-control-static bg-white"
          readonly
          v-model="model.no_kontrak"
        ></b-form-input>
      </b-input-group>
      <hr> -->
      <b-input-group>
        <b-input-group-prepend>
          <label class="lbl-left">No. Jaminan</label>
        </b-input-group-prepend>
        <b-form-input
          v-model="model.no_jaminan"
          placeholder="No. Jaminan"
          disabled
        ></b-form-input>
        <!-- :state="!$v.model.no_jaminan.$error" -->
      </b-input-group>
      <b-input-group>
        <b-input-group-prepend>
          <label class="lbl-left pt-0">Tipe Jaminan</label>
        </b-input-group-prepend>
        <b-form-radio-group
          id="tipejaminan"
          v-model="model.tipejaminan"
          :state="!$v.model.tipejaminan.$error"
          :options="optTipeJaminan"
        ></b-form-radio-group>
      </b-input-group>
      <b-input-group>
        <b-input-group-prepend>
          <label class="lbl-left">Nama Jaminan</label>
        </b-input-group-prepend>
        <b-form-input
          v-model="model.namajaminan"
          :state="!$v.model.namajaminan.$error"
          placeholder="Mobil Alphard / Rumah tinggal mewah"
        ></b-form-input>
      </b-input-group>
      <b-input-group>
        <b-input-group-prepend>
          <label class="lbl-left">Alamat Jaminan</label>
        </b-input-group-prepend>
        <b-form-input v-model="model.alamat" :state="!$v.model.alamat.$error"></b-form-input>
      </b-input-group>
      <b-input-group class="sub-section-input">
        <b-input-group-prepend>
          <label class="sub-section-label">Kelurahan</label>
        </b-input-group-prepend>
        <b-form-input placeholder v-model="model.kelurahan"></b-form-input>
        <b-input-group-prepend>
          <label class="sub-section-label text-right mr-2">Kecamatan</label>
        </b-input-group-prepend>
        <b-form-input placeholder v-model="model.kecamatan"></b-form-input>
      </b-input-group>
      <b-input-group class="sub-section-input">
        <b-input-group-prepend>
          <label class="sub-section-label">Kota</label>
        </b-input-group-prepend>
        <b-form-input placeholder v-model="model.kota" :state="!$v.model.kota.$error"></b-form-input>
        <b-input-group-prepend>
          <label class="sub-section-label text-right mr-2">Propinsi</label>
        </b-input-group-prepend>
        <b-form-input placeholder v-model="model.provinsi"></b-form-input>
      </b-input-group>
      <b-input-group class="sub-section-input" style="width:calc(50% - 103px)">
        <b-input-group-prepend>
          <label class="sub-section-label">Kodepos</label>
        </b-input-group-prepend>
        <b-form-input placeholder v-model="model.kodepos"></b-form-input>
      </b-input-group>

      <div v-if="model.tipejaminan=='Kendaraan'">
        <b-row>
          <b-col lg="7">
            <b-input-group>
              <b-input-group-prepend>
                <label class="lbl-left">Pemilik A/N</label>
              </b-input-group-prepend>
              <b-form-input v-model="model.pemilikjaminan" :state="!$v.model.pemilikjaminan.$error"></b-form-input>
            </b-input-group>
          </b-col>
        </b-row>
        <b-input-group>
          <b-input-group-prepend>
            <label class="lbl-left">No. BPKB</label>
          </b-input-group-prepend>
          <b-form-input v-model="model.bpkb" :state="!$v.model.bpkb.$error"></b-form-input>
          <b-input-group-prepend>
            <label class="sub-section-label text-right mr-2">No. STNK</label>
          </b-input-group-prepend>
          <b-form-input v-model="model.stnk" :state="!$v.model.stnk.$error"></b-form-input>
        </b-input-group>
        <b-input-group>
          <b-input-group-prepend>
            <label class="lbl-left">Status STNK</label>
          </b-input-group-prepend>
          <b-form-input v-model="model.statusstnk" :state="!$v.model.statusstnk.$error"></b-form-input>
          <b-input-group-prepend>
            <label class="sub-section-label text-right mr-2">Tanggal STNK</label>
          </b-input-group-prepend>
          <b-form-input
            type="date"
            v-model="model.tanggalstnk"
            :state="!$v.model.tanggalstnk.$error"
          ></b-form-input>
        </b-input-group>
      </div>
      <div v-if="model.tipejaminan=='FA'">
        <b-input-group>
          <b-input-group-prepend>
            <label class="lbl-left">Luas Tanah</label>
          </b-input-group-prepend>
          <my-number
            style="max-width:150px"
            v-model="model.luastanah"
            :state="!$v.model.luastanah.$error"
          ></my-number>
          <b-input-group-append>
            <label class="ml-2 mr-5">
              /m
              <sup>2</sup>
            </label>
          </b-input-group-append>
          <b-input-group-prepend>
            <label class="sub-section-label text-right mr-2">Luas Bangunan</label>
          </b-input-group-prepend>
          <my-number
            style="max-width:150px"
            v-model="model.luasbangunan"
            :state="!$v.model.luasbangunan.$error"
          ></my-number>
          <b-input-group-append>
            <label class="ml-2">
              /m
              <sup>2</sup>
            </label>
          </b-input-group-append>
        </b-input-group>
        <b-input-group>
          <b-input-group-prepend>
            <label class="lbl-left">Status Sertifikat</label>
          </b-input-group-prepend>
          <b-form-radio-group
            v-model="model.sertifikatstatus"
            :options="optStsSertifikat"
          ></b-form-radio-group>
          <b-form-input
            v-if="model.sertifikatstatus =='lainnya'"
            placeholder="Sebutkan"
            v-model="model.otherstatussertifikat"
            :state="!$v.model.otherstatussertifikat.$error"
          ></b-form-input>
        </b-input-group>
        <b-input-group>
          <b-input-group-prepend>
            <label class="lbl-left">No Sertifikat</label>
          </b-input-group-prepend>
          <b-form-input v-model="model.sertifikatno" :state="!$v.model.sertifikatno.$error"></b-form-input>
          <b-input-group-prepend>
            <label class="sub-section-label text-right mr-2">Sertifikat Atas Nama</label>
          </b-input-group-prepend>
          <b-form-input v-model="model.pemilikjaminan" :state="!$v.model.pemilikjaminan.$error"></b-form-input>
        </b-input-group>
        <b-input-group>
          <b-input-group-prepend>
            <label class="lbl-left">Status PBB</label>
          </b-input-group-prepend>
          <b-form-input v-model="model.statuspbb"></b-form-input>
          <b-input-group-prepend>
            <label class="sub-section-label text-right mr-2">Tanggal PBB</label>
          </b-input-group-prepend>
          <b-form-input type="date" v-model="model.tanggalpbb"></b-form-input>
        </b-input-group>
        <b-input-group>
          <b-input-group-prepend>
            <label class="lbl-left">Status Asuransi</label>
          </b-input-group-prepend>
          <b-form-input v-model="model.statusasuransi"></b-form-input>
          <b-input-group-prepend>
            <label class="sub-section-label text-right mr-2">No. IMB</label>
          </b-input-group-prepend>
          <b-form-input v-model="model.noimb"></b-form-input>
        </b-input-group>
      </div>
      <b-row>
        <b-col lg="6">
          <b-input-group>
            <b-input-group-prepend>
              <label class="lbl-left">Nilai Jaminan</label>
            </b-input-group-prepend>
            <b-input-group-prepend>
              <label class="mr-3" style="width:20px !important;">Rp.</label>
            </b-input-group-prepend>
            <my-number
              class="mynumb-penghasilan text-right"
              v-model="model.nilaijaminan"
              :state="!$v.model.nilaijaminan.$error"
              :precision="2"
            ></my-number>
          </b-input-group>
        </b-col>
        <!-- <b-col lg="6">
          <b-input-group>
            <b-input-group-prepend>
              <label class="sub-section-label text-right mr-2">Hub. Dgn Peminjam</label>
            </b-input-group-prepend>
            <b-form-input v-model="model.hubungandgnpemilik"></b-form-input>
          </b-input-group>
        </b-col> -->
      </b-row>

      <hr>
      <b-table
        sticky-header 
        class="mb-0"
        ref="table"
        outlined
        responsive
        striped
        hover
        small
        style="font-size:smaller;max-height:500px !important;"
        :items="tblDataPinjaman.items"
        :fields="tblFieldsPinjaman"
        :current-page="tblDataPinjaman.page"
        :per-page="tblDataPinjaman.limit"
        :sort-by.sync="tblDataPinjaman.sortBy"
        :sort-desc.sync="tblDataPinjaman.sortDesc"
        :key="tblDataPinjaman.limit"
        :busy="isBusyTblAngsuran"
        :filter="filter"
        :filterIncludedFields="filterOn"
        @filtered="onFiltered"
        show-empty
        caption-top
      >

      <template #table-caption><h5>List Pinjaman atas Jaminan</h5></template>
      <template v-slot:cell(index)="data">{{ data.index + 1 }}</template>
      <template v-slot:cell(duedate)="data">{{data.item.duedate | moment("DD/MM/YY")}}</template>
      <template v-slot:cell(rrd_dt)="data">{{data.item.rrd_dt | moment("DD/MM/YY")}}</template>
      <template v-slot:cell(released)="data">{{data.item.released | moment("DD/MM/YY")}}</template>
      </b-table>

    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading> 
  </div>
</template>

<script>
import toastr from "mini-toastr";
import moment from "moment";
import Loading from 'vue-loading-overlay';
import myNumber from "../../components/my-number";
import { validationMixin } from "vuelidate";
import { required, minValue, requiredIf } from "vuelidate/lib/validators";
toastr.init();
import jaminan from "../../apis/agunankredit";
export default {
  components: { Loading, myNumber },
  mixins: [validationMixin],
  validations: {
    model: {
      tipejaminan: { required },
      namajaminan: { required },
      alamat: { required },
      // kelurahan: { required },
      // kecamatan: { required },
      kota: { required },
      //provinsi: { required },
      // kodepos
      bpkb: {
        required: requiredIf(function (value) {
          return this.ifKendaraan;
        }),
      },
      stnk: {
        required: requiredIf(function (value) {
          return this.ifKendaraan;
        }),
      },
      statusstnk: {
        required: requiredIf(function (value) {
          return this.ifKendaraan;
        }),
      },
      tanggalstnk: {
        required: requiredIf(function (value) {
          return this.ifKendaraan;
        }),
      },
      luastanah: {
        required: requiredIf(function (value) {
          return this.ifFAsset;
        }),
      },
      luasbangunan: {
        required: requiredIf(function (value) {
          return this.ifFAsset;
        }),
      },
      sertifikatno: {
        required: requiredIf(function (value) {
          return this.ifFAsset;
        }),
      },
      // sertifikatstatus: {
      //   required: requiredIf(function (value) {
      //     return this.ifFAsset;
      //   }),
      // },
      otherstatussertifikat: {
        required: requiredIf(function (value) {
          return this.ifstssrtfkother;
        }),
      },
      // statusasuransi: {
      //   required: requiredIf(function (value) {
      //     return this.ifFAsset;
      //   }),
      // },
      // tanggalpbb: {
      //   required: requiredIf(function (value) {
      //     return this.ifFAsset;
      //   }),
      // },
      // statuspbb: {
      //   required: requiredIf(function (value) {
      //     return this.ifFAsset;
      //   }),
      // },
      // noimb: {
      //   required: requiredIf(function (value) {
      //     return this.ifFAsset;
      //   }),
      // },
      pemilikjaminan: {
        required,
        // : requiredIf(function (value) {
        //   return this.ifFAsset;
        // }),
      },
      // hubungandgnpemilik
      nilaijaminan: { required },
    },
  },
  data() {
    return {
      model: {
        CustName: "",
        no_agreement: "",
        no_kontrak: "",
        namajaminan: "",
        alamat: "",
        kelurahan: "",
        kecamatan: "",
        kota: "",
        provinsi: "",
        kodepos: "",
        tipejaminan: "FA",
        luastanah: 0,
        luasbangunan: 0,
        sertifikatstatus: "HM",
        otherstatussertifikat: "",
        sertifikatno: null,
        pemilikjaminan: null,
        hubungandgnpemilik: null,
        noimb: null,
        statuspbb: null,
        tanggalpbb: null,
        bpkb: null,
        stnk: null,
        statusstnk: null,
        tanggalstnk: null,
        nilaijaminan: 0,
        statusasuransi: null,
      },
      optTipeJaminan: [
        { text: "FA", value: "FA" },
        { text: "Kendaraan", value: "Kendaraan" },
      ],
      optStsSertifikat: [
        { text: "Hak Milik", value: "HM" },
        { text: "Hak Guna Bangunan", value: "HGB" },
        { text: "Hak Guna Usaha", value: "HGU" },
        { text: "Induk", value: "induk" },
        { text: "Lainnya", value: "lainnya" },
      ],

      tblDataPinjaman: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: "jaminankey",
        sortDesc: false,
        pemilikjaminan: null,
        lokasijaminan: null,
        nilai1: 0,
        nilai2: 0,
        no_kontrak: null,
        tipejaminan: "",
        statusasuransi: "",
        jaminankeys: [],
        sourceproject: this.$store.state.user.compcode||"",
        selected:[]
      },
      isLoading:false,
      isdetail: false,
      isBusyTblAngsuran: false,
      filter: "",
      filterOn: ["statuspay"],

    };
  },
  props: [],
  computed: {
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    ifKendaraan() {
      return this.model.tipejaminan == "Kendaraan" ? true : false;
    },
    ifFAsset() {
      return this.model.tipejaminan == "FA" ? true : false;
    },
    ifstssrtfkother() {
      return this.model.sertifikatstatus == "lainnya" ? true : false;
    },

    tblFieldsPinjaman() {
      const fields = [
        { key: "index", label: "No." },
        {
          key: "no_agreement",
          label: "No Agreement",
          thClass: "text-center",
          thStyle: "width:500px",
          sortable: true,
        },
        {
          key: "no_kontrak",
          label: "No. Kontrak",
          thClass: "text-center",
          thStyle: "width:500px",
          sortable: true,
        },
        {
          key: "CustCode",
          label: "Debitur No. (CIF)",
          thClass: "text-center",
          thStyle: "width:500px",
          sortable: true,
        },
        {
          key: "CustName",
          label: "Debitur Name",
          thClass: "text-center",
          thStyle: "width:500px",
          sortable: true,
        },
        {
          key: "hubungandgnpemilik",
          label: "Hubungan dengan Pemilik",
          thClass: "text-center",
          thStyle: "width:500px",
          sortable: true,
        },
        // {
        //   key: "duedate",
        //   label: "Maturity Date",
        //   thClass: "text-center",
        //   tdClass: "text-right",
        //   thStyle: "width:500px",
        //   sortable: true,
        // },
        // {
        //   key: "rrd_dt",
        //   label: "RRD Date",
        //   thClass: "text-center",
        //   tdClass: "text-right",
        //   thStyle: "width:500px",
        //   sortable: true,
        // },
        {
          key: "released",
          label: "Release Date",
          thClass: "text-center",
          tdClass: "text-right",
          thStyle: "width:500px",
          sortable: true,
        },
        // {
        //   key: "installment_amount",
        //   label: "Angsuran / Bulan",
        //   thClass: "text-center",
        //   tdClass: "text-right",
        //   thStyle: "width:500px",
        //   sortable: true,
        // },
        // {
        //   key: "principal",
        //   label: "Plafond Pinjaman",
        //   thClass: "text-center",
        //   tdClass: "text-right",
        //   thStyle: "width:500px",
        //   sortable: true,
        // },
        // {
        //   key: "tenor",
        //   label: "Jangka Waktu",
        //   thClass: "text-center",
        //   tdClass: "text-right",
        //   thStyle: "width:500px",
        //   sortable: true,
        // },
        // {
        //   key: "bunga_tarifthn",
        //   label: "Bunga / Tahun",
        //   thClass: "text-center",
        //   tdClass: "text-right",
        //   thStyle: "width:500px",
        //   sortable: true,
        // },
        // {
        //   key: "bungaod_tarifthn",
        //   label: "Bunga Over Draft",
        //   thClass: "text-center",
        //   tdClass: "text-right",
        //   thStyle: "width:500px",
        //   sortable: true,
        // },
      ];
      return fields;
    },

  },
  async created() {
    if (this.$route.params.jaminankey) {
      this.model.jaminankey = this.$route.params.jaminankey;
      this.getdata();

      //get list pinjaman on jaminan
      const data = await jaminan.getPinjamanAgunan(this.$route.params.jaminankey);
      this.tblDataPinjaman.items=data;
      this.tblDataPinjaman.total = data.length;


    }
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.tblData.total = filteredItems.length;
      this.tblData.page = 1;
    },
    async getdata() {
      const jaminankey = this.model.jaminankey;
      const res = await jaminan.detail(jaminankey);
      // this.model = res;
      for (const key in res) {
        this.model[key] = res[key];
      }
      this.model.tanggalstnk =
        (this.model.tanggalstnk || "") == ""
          ? null
          : moment(this.model.tanggalstnk).format("YYYY-MM-DD");

      this.model.tanggalpbb =
        (this.model.tanggalpbb || "") == ""
          ? null
          : moment(this.model.tanggalpbb).format("YYYY-MM-DD");

      this.model.nilaijaminan = this.model.nilaijaminan.toLocaleString(
        undefined,
        { maximumFractionDigits: 2 }
      );
      console.log('#this.model',this.model)
    },
    async save() {
      if (this.invalidModel) {
        console.log("validation : ", this.$v.model);
        console.log("model obj : ", this.model);
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
      } else {
        try {
          await jaminan.save(this.model);
          toastr.success("Data pinjaman berhasil disimpan", "Info");
          this.close();
        } catch (error) {
          this.isLoading = false;
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      }
    },
    close() {
      router.push({ name: "loan.agunanlist" });
    },
  },
};
</script>

<style lang="scss" scoped>
label {
  margin-top: 4px !important;
}
// .input-group {
//   margin-top: 2px;
// }
.lbl-left {
  width: 200px !important;
}
.sub-section-input {
  margin-left: 200px;
  width: calc(100% - 200px);
}
.sub-section-label {
  width: 150px;
}
.mynumb-penghasilan {
  max-width: 200px;
}
</style>